import { ca } from '@cian/analytics';

export function trackRightReliableLabelClick(label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label,
    useLastProducts: true,
  });
}
